// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { SubnetSchema } from './SubnetSchema';

/////////////////////////////////////////
// SUBNET RELATION SCHEMA
/////////////////////////////////////////

export type SubnetRelations = {
  surface: ExternalNetworkWithRelations;
  parent?: SubnetWithRelations | null;
  children: SubnetWithRelations[];
};

export type SubnetWithRelations = z.infer<typeof SubnetSchema> & SubnetRelations

export const SubnetWithRelationsSchema: z.ZodType<SubnetWithRelations> = SubnetSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  parent: z.lazy(() => SubnetWithRelationsSchema).nullable(),
  children: z.lazy(() => SubnetWithRelationsSchema).array(),
}))